import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IDCard from '../components/IDCard';

function logout(navigate) {
  localStorage.removeItem('access');
  localStorage.removeItem('refresh');
  localStorage.removeItem('auth_token');
  navigate('/login', { replace: true });
}

export default function IDCardPage() {
  const [employeeData, setEmployeeData] = useState(null);
  const [qrPayload, setQrPayload] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAll = async () => {
      const token = localStorage.getItem('access') ?? localStorage.getItem('auth_token');
      if (!token) {
        navigate('/login', { replace: true });
        return;
      }
      const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
      try {
        // 社員情報と QR トークンを並行取得
        const [meRes, qrRes] = await Promise.all([
          fetch('/api/employee/me/', { headers, credentials: 'include' }),
          fetch('/api/employee/qr-token/', { headers, credentials: 'include' }),
        ]);
        if (!meRes.ok) throw new Error('社員情報の取得に失敗しました。');
        const meData = await meRes.json();
        setEmployeeData(meData);

        if (qrRes.ok) {
          const qrData = await qrRes.json();
          setQrPayload(qrData);
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'データの取得に失敗しました。');
        logout(navigate);
      }
    };
    fetchAll();
  }, [navigate]);

  if (error) return <div className="p-4 text-red-500">{error}</div>;
  if (!employeeData) {
    return (
      <div className="min-h-screen bg-slate-100 py-8 flex items-center justify-center">
        <div className="animate-pulse rounded-2xl bg-white shadow-lg w-full max-w-sm mx-auto h-80" />
      </div>
    );
  }

  const cardEmployee = {
    name: employeeData.name ?? employeeData.last_name,
    departmentName: employeeData.departmentName ?? employeeData.department_name,
    positionName: employeeData.position ?? employeeData.position_name,
    employeeId: employeeData.memberId ?? employeeData.employeeId ?? employeeData.employee_id,
  };

  return (
    <div className="min-h-screen bg-slate-100 py-8 id-card-fade-in">
      <IDCard employee={cardEmployee} qrPayload={qrPayload} />
      <div className="flex justify-center mt-6">
        <button
          onClick={() => logout(navigate)}
          className="text-sm text-slate-500 underline"
        >
          ログアウト
        </button>
      </div>
    </div>
  );
}
